import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "role-generator"
};
const _hoisted_2 = {
  style: {
    "display": "flex",
    "gap": "32px"
  }
};
const _hoisted_3 = {
  class: "left-side"
};
const _hoisted_4 = {
  class: "group-container"
};
const _hoisted_5 = {
  class: "group-container"
};
const _hoisted_6 = {
  class: "group-title"
};
const _hoisted_7 = {
  class: "capability-indicator"
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  class: "max-value"
};
const _hoisted_10 = {
  class: "right-side"
};
const _hoisted_11 = {
  class: "group-container"
};
const _hoisted_12 = {
  class: "group-title"
};
const _hoisted_13 = {
  key: 0,
  class: "tips emphasize"
};
const _hoisted_14 = {
  class: "desc"
};
const _hoisted_15 = {
  key: 1
};
const _hoisted_16 = {
  class: "desc"
};
const _hoisted_17 = {
  class: "min-value"
};
const _hoisted_18 = {
  class: "max-value"
};
const _hoisted_19 = {
  style: {
    "margin-right": "0.5rem"
  }
};
const _hoisted_20 = {
  style: {
    "margin-right": "0.5rem"
  }
};
const _hoisted_21 = {
  style: {
    "margin-right": "0.5rem"
  }
};
const _hoisted_22 = {
  class: "generated-item-value"
};
const _hoisted_23 = {
  class: "generated-item-value"
};
const _hoisted_24 = {
  class: "generated-item-value"
};
const _hoisted_25 = {
  class: "group-container"
};
const _hoisted_26 = {
  class: "intro"
};
const _hoisted_27 = {
  key: 0
};
const _hoisted_28 = {
  class: "capabilities-grid-container"
};
const _hoisted_29 = ["onClick"];
const _hoisted_30 = {
  class: "role-capability-group-container"
};
const _hoisted_31 = ["onClick"];
const _hoisted_32 = {
  class: "role-capability-item-content"
};
const _hoisted_33 = {
  class: "desc"
};
const _hoisted_34 = {
  class: "role-capability-item-content"
};
const _hoisted_35 = {
  class: "explain"
};
const _hoisted_36 = {
  class: "role-capability-item-content"
};
const _hoisted_37 = {
  class: "min-value"
};
const _hoisted_38 = {
  class: "max-value"
};
const _hoisted_39 = {
  class: "dialog-footer"
};
const _hoisted_40 = {
  class: "dialog-footer"
};
import { computed, ref, onMounted, watch } from 'vue';
import { ElButton, ElCol, ElInput, ElMessage, ElOption, ElPopover, ElProgress, ElRow, ElSegmented, ElSelect } from 'element-plus';
import { CloseBold, Postcard, UserFilled, List, Refresh } from '@element-plus/icons-vue';
import { request } from '@/manager/net_manager';
import { getGender, getProperty, getRace, getCapability, getCapabilityBaseValue, getDamageAndBuild, getMovement, getHealthPoint, getMagicPoint } from '@/tools/utils';
import AvatarSelectorHorizontal from '@/components/Common/AvatarSelector-Horizontal.vue';
import CapabilityRadar from '@/components/Common/CapabilityRadar.vue';
import 'element-plus/es/components/progress/style/css';
import store from "@/store"; // pre-declaration

export default {
  __name: 'RoleGenerator',
  props: {
    role: {
      type: Object,
      required: false
    }
  },
  emits: ['completeRole'],

  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit; // constants

    const propertyKeys = ['str', 'con', 'siz', 'dex', 'app', 'int', 'pow', 'edu']; // refs

    const parameters = ref({
      avatar: '',
      age: 20,
      nickname: '',
      work: '',
      nationality: '',
      era: '',
      biography: '',
      properties: {
        'str': 30,
        'con': 30,
        'siz': 30,
        'dex': 30,
        'app': 30,
        'int': 30,
        'pow': 30,
        'edu': 30
      },
      capabilities: []
    }); // refs

    const message = ref(null);
    const confirmationDialog = ref(false);
    const confirmationTitle = ref('');
    const confirmationTips = ref('');
    const secondaryConfirmationDialog = ref(false);
    const secondaryConfirmation = ref(false);
    const avatarSelector = ref(null);
    const basePropertyPoint = ref({
      'str': [30, 90],
      'con': [30, 90],
      'siz': [30, 90],
      'dex': [30, 90],
      'app': [30, 90],
      'int': [30, 85],
      'pow': [30, 80],
      'edu': [20, 80]
    });
    const capabilityType = ref(null);
    const selectedCapabilityItem = ref(null);
    const convertedData = ref({}); // computed

    const capabilityConfigure = computed(() => store.state.capability_configure);
    const assignedPropertyPoint = computed(() => {
      let totalPoint = 0;

      for (const key in parameters.value['properties']) {
        const value = parameters.value['properties'][key];
        totalPoint += value;
      } // let convertPoint = ''


      return totalPoint;
    });
    const adjustPropertyPoint = computed(() => {
      const age = parameters.value['age'];
      const ageDifference = age - 20;
      return {
        'str': [-Math.floor(ageDifference / 3), -Math.floor(ageDifference / 3)],
        'con': [-Math.floor(ageDifference / 6), -Math.floor(ageDifference / 6)],
        'siz': [0, 0],
        'dex': [-Math.floor(ageDifference / 3), -Math.floor(ageDifference / 3)],
        'app': [-Math.floor(ageDifference / 6), -Math.floor(ageDifference / 6)],
        'int': [0, Math.floor(ageDifference / 6)],
        'pow': [0, Math.floor(ageDifference / 3)],
        'edu': [Math.floor(ageDifference / 3), Math.floor(ageDifference / 3)]
      };
    });
    const assignablePropertyPoint = computed(() => {
      const age = parameters.value['age'];
      return 490 - Math.floor((age - 20) * 0.5);
    });
    const conversionCoefficient = computed(() => {
      const age = parameters.value['age'];
      return Math.floor((1.0 + (age - 20) * 0.03) * 10) / 10.0;
    });
    const selectedCapabilityDict = computed(() => {
      if (!capabilityType.value) return null;
      return capabilityConfigure.value[capabilityType.value.toString()];
    });
    const convertedPropertyPoint = computed(() => {
      return Object.values(convertedData.value).reduce((point, group) => {
        return point + Object.values(group.converted_point).reduce((sum, value) => sum + value, 0);
      }, 0);
    });
    const totalAssignableCapabilityPoint = computed(() => {
      return Object.values(convertedData.value).reduce((point, group) => {
        return point + Object.keys(group.compatibility).map(key => {
          return Math.floor(group['compatibility'][key] * group['converted_point'][key] * conversionCoefficient.value);
        }).reduce((sum, value) => sum + value, 0);
      }, 0);
    });
    const totalAssignedCapabilityPoint = computed(() => {
      return parameters.value['capabilities'].map(item => item['nature_value']).reduce((sum, value) => sum + value, 0);
    });
    const capabilitiesIds = computed(() => {
      return parameters.value['capabilities'].map(item => item.capability_id.toString());
    });
    const acquiredCapabilityTypes = computed(() => {
      const typesSet = new Set();
      parameters.value['capabilities'].forEach(item => typesSet.add(item['type']['capability_type_id'].toString()));
      return Array.from(typesSet);
    });
    const capabilityTypeOptions = computed(() => {
      if (!capabilityConfigure.value) return [];
      return Object.values(capabilityConfigure.value).map(item => item.capability_type_id.toString());
    });
    const capabilities = computed(() => {
      if (!capabilityType.value) return [];
      const typeData = capabilityConfigure.value[capabilityType.value];
      if (!typeData) return [];
      return Object.values(typeData?.children ?? {}).filter(item => !item.extraordinary);
    });
    const assignableCapabilityPoint = computed(() => {
      return Object.fromEntries(capabilityTypeOptions.value.map(typeId => {
        return [typeId, propertyKeys.reduce((sum, key) => {
          const buffer = convertedData.value[typeId];
          return sum + Math.floor(buffer['converted_point'][key] * buffer['compatibility'][key] * conversionCoefficient.value);
        }, 0)];
      }));
    });
    const assignedCapabilityPoint = computed(() => {
      return Object.fromEntries(capabilityTypeOptions.value.map(typeId => {
        const totalPoint = parameters.value['capabilities'].filter(item => item['type']['capability_type_id'].toString() === typeId.toString()).map(item => item['nature_value']).reduce((sum, value) => sum + value, 0);
        return [typeId, totalPoint];
      }));
    }); // const capabilitiesRangeData = computed(() => {
    //   return Object.fromEntries(parameters.value['capabilities'].map(capability => {
    //     const buffer = getCapabilityBaseValue(capability.base_value, parameters.value.properties)
    //     const capabilityTypeId = capability.type.capability_type_id.toString()
    //     const minValue = parseInt(buffer[0])
    //     let maxValue = 70
    //     const assignablePoint = assignableCapabilityPoint.value[capabilityTypeId] - assignedCapabilityPoint.value[capabilityTypeId]
    //     // console.log(assignableCapabilityPoint.value[capabilityTypeId], assignedCapabilityPoint.value[capabilityTypeId], assignablePoint)
    //     if (assignablePoint <= 0) maxValue = minValue
    //     else if (assignablePoint < maxValue - minValue) maxValue = assignablePoint + minValue
    //
    //     const capabilityId = capability.capability_id.toString()
    //     return [[capabilityId], {
    //       'minValue': minValue,
    //       'maxValue': maxValue,
    //     }]
    //   }))
    // })
    // functions

    const getPopoverContent = key => {
      let minValueAdjust = adjustPropertyPoint.value[key][0];
      minValueAdjust = minValueAdjust >= 0 ? ` + ${minValueAdjust}` : ` - ${Math.abs(minValueAdjust)}`;
      let maxValueAdjust = adjustPropertyPoint.value[key][1];
      maxValueAdjust = maxValueAdjust >= 0 ? ` + ${maxValueAdjust}` : ` - ${Math.abs(maxValueAdjust)}`;
      return `属性最低至${basePropertyPoint.value[key][0]}${minValueAdjust}\n属性最高至${basePropertyPoint.value[key][1]}${maxValueAdjust}`;
    };

    const getPropertyMinValue = key => {
      let minValue = basePropertyPoint.value[key][0] + adjustPropertyPoint.value[key][0];

      if (props.role) {
        return Math.min(minValue, props.role['properties'][key] ?? 30);
      }

      return minValue;
    };

    const getPropertyMaxValue = key => {
      let maxValue = basePropertyPoint.value[key][1] + adjustPropertyPoint.value[key][1];

      if (props.role) {
        return Math.max(maxValue, props.role['properties'][key] ?? 90);
      }

      return maxValue;
    };

    const propertyChanged = key => {
      const points = assignablePropertyPoint.value - assignedPropertyPoint.value; // console.log(`assignablePropertyPoint.value = ${assignablePropertyPoint.value} assignedPropertyPoint.value = ${assignedPropertyPoint.value}`)
      // console.log(`property ${key} changed: ${points}`)

      if (points <= 0) {
        parameters.value['properties'][key] = parameters.value['properties'][key] + points;
      }
    };

    const getPropertyCompatibility = key => {
      if (selectedCapabilityDict.value) {
        const value = selectedCapabilityDict.value[key];
        return `${parseFloat(value) * 100}`;
      }

      return '0';
    };

    const compatibilityTextStyle = value => {
      const alpha = parseInt(value) / 100; // 转换为 0-1 范围

      return {
        color: `rgba(44, 44, 44, ${alpha})` // 黑色 + 动态透明度

      };
    };

    const addCapability = capabilityData => {
      if (message.value) {
        message.value.close();
      } // console.log(`capabilityType.value = ${JSON.stringify(capabilityType.value)}`)


      const capabilityId = capabilityData.capability_id.toString();

      if (capabilitiesIds.value.includes(capabilityId)) {
        parameters.value['capabilities'] = parameters.value['capabilities'].filter(item => item.capability_id.toString() !== capabilityId);
      } else {
        const item = { ...getCapability(capabilityId, parameters.value),
          ...{
            'nature_value': 0
          }
        };
        parameters.value['capabilities'].unshift(item);
        if (!selectedCapabilityItem.value) selectedCapabilityItem.value = item;
      }
    };

    const removeCapability = (event, capabilityData) => {
      const capabilityId = capabilityData.capability_id.toString();

      if (capabilitiesIds.value.includes(capabilityId)) {
        parameters.value['capabilities'] = parameters.value['capabilities'].filter(item => item['capability_id'].toString() !== capabilityId);

        if (selectedCapabilityItem.value && selectedCapabilityItem.value['capability_id'].toString() === capabilityId && parameters.value['capabilities'].length > 0) {
          clickCapabilityItem(parameters.value['capabilities'][0]);
        }
      }

      event.stopPropagation();
    };

    const clickCapabilityItem = item => {
      selectedCapabilityItem.value = item;

      if (item['type']['capability_type_id'] !== capabilityType.value) {
        capabilityType.value = item['type']['capability_type_id'].toString();
      }
    };

    const getConvertMaxValue = key => {
      if (!capabilityType.value) return 0;
      const convertedValue = Object.entries(convertedData.value).map(([typeId, value]) => {
        if (typeId.toString() !== capabilityType.value.toString()) {
          return value.converted_point[key];
        }

        return 0;
      }).reduce((sum, value) => sum + value, 0);
      return parameters.value.properties[key] - convertedValue;
    };

    const getCapabilityMinValue = capability => {
      const buffer = getCapabilityBaseValue(capability.base_value, parameters.value.properties);
      return parseInt(buffer[0]);
    };

    const getCapabilityMaxValue = capability => {
      const minValue = getCapabilityMinValue(capability);
      const capabilityTypeId = capability.type.capability_type_id.toString();
      const assignablePoint = assignableCapabilityPoint.value[capabilityTypeId] - assignedCapabilityPoint.value[capabilityTypeId]; // console.log(assignableCapabilityPoint.value[capabilityTypeId], assignedCapabilityPoint.value[capabilityTypeId], assignablePoint)

      if (assignablePoint < 0) return minValue;
      return Math.min(70, assignablePoint + minValue + capability.nature_value);
    };

    const selectedAvatar = avatar => {
      parameters.value['avatar'] = avatar;
    };

    const reorderCapabilities = () => {
      parameters.value['capabilities'].sort((a, b) => {
        return parseInt(a['type']['capability_type_id']) - parseInt(b['type']['capability_type_id']);
      });
    };

    const resetConvertedData = () => {
      convertedData.value = Object.fromEntries(Object.entries(capabilityConfigure.value).map(([key, value]) => {
        return [key, {
          'desc': value.desc,
          'compatibility': Object.fromEntries(Object.entries(value).filter(([k]) => propertyKeys.includes(k))),
          'converted_point': Object.fromEntries(propertyKeys.map(k => [k, 0]))
        }];
      }));
    };

    const submitRole = async (event, force = false) => {
      const ignoreKeys = ['biography'];
      const existsKeys = ['gender', 'race'];
      const vacantDict = {
        'avatar': '尚未选择角色头像',
        'nickname': '需要角色名',
        'work': '需要职业',
        'nationality': '需要国籍',
        'era': '需要链接年代',
        'gender': '需要性别',
        'race': '需要种族'
      };

      if (message.value) {
        message.value.close();
      } // console.log(`parameters.value= ${JSON.stringify(parameters.value)}`)


      let vacantKey = null;

      for (const key in parameters.value) {
        const value = parameters.value[key];

        if (typeof value === 'string' && (value === '' || value === null) && !ignoreKeys.includes(key)) {
          // console.log(`key=${key}: ${value}`)
          vacantKey = key;
          break;
        }
      }

      if (!vacantKey) {
        for (const key of existsKeys) {
          if (!(key in parameters.value)) {
            vacantKey = key;
          }
        }
      }

      if (vacantKey) {
        if (Object.keys(vacantDict).includes(vacantKey)) {
          message.value = ElMessage.error({
            message: vacantDict[vacantKey],
            duration: 1500
          });
          return;
        }
      } // console.log(`parameters.value['avatar'] = ${parameters.value['avatar']}`)


      if (parameters.value['avatar'] && !parameters.value['avatar'].startsWith('default') && !parameters.value['avatar'].startsWith('http')) {
        if (avatarSelector.value) {
          let result = await avatarSelector.value.uploadAvatar();

          if (!result) {
            message.value = ElMessage.error({
              message: '头像上传失败，请重新尝试',
              duration: 1500
            });
            return;
          } // console.log(`uploadAvatar result = ${JSON.stringify(result)}`)


          parameters.value['avatar'] = result;
        }
      }

      if (!force) {
        if (assignedPropertyPoint.value < assignablePropertyPoint.value) {
          confirmationDialog.value = true;
          confirmationTitle.value = `尚余${assignablePropertyPoint.value - assignedPropertyPoint.value}属性点可分配`;
          confirmationTips.value = '角色在链接雾海之后，除重构角色卡外（每张角色卡在链接之后仅有一次重构机会），不再具备分配天性属性点的可能，确定以当前状态进入雾海吗？';
          return;
        } else if (parameters.value.capabilities.length === 0) {
          confirmationDialog.value = true;
          confirmationTitle.value = `能力列表空缺`;
          confirmationTips.value = '角色在链接雾海之后，除重构角色卡外（每张角色卡在链接之后仅有一次重构机会），不再具备分配天性能力点的可能，确定以当前状态进入雾海吗？';
          return;
        } else if (convertedPropertyPoint.value < assignedPropertyPoint.value) {
          confirmationDialog.value = true;
          confirmationTitle.value = `尚余${assignedPropertyPoint.value - convertedPropertyPoint.value}属性点可转化`;
          confirmationTips.value = '角色在链接雾海之后，除重构角色卡外（每张角色卡在链接之后仅有一次重构机会），不再具备分配天性能力点的可能，确定以当前状态进入雾海吗？';
          return;
        } else if (totalAssignedCapabilityPoint.value < totalAssignableCapabilityPoint.value) {
          confirmationDialog.value = true;
          confirmationTitle.value = `尚余${totalAssignableCapabilityPoint.value - totalAssignedCapabilityPoint.value}能力点可分配`;
          confirmationTips.value = '角色在链接雾海之后，除重构角色卡外（每张角色卡在链接之后仅有一次重构机会），不再具备分配天性能力点的可能，确定以当前状态进入雾海吗？';
          return;
        }
      }

      if (props.role && !secondaryConfirmation.value) {
        secondaryConfirmationDialog.value = true;
        confirmationTitle.value = `最终确认`;
        confirmationTips.value = `确认按照当前设定消耗重构次数 (1 / ${props.role['reborn']}) 吗`;
        return;
      }

      let capabilities = parameters.value.capabilities.filter(item => item['nature_value'] !== 0).map(item => ({
        [item['capability_id']]: item['nature_value']
      }));
      capabilities = capabilities.reduce((acc, obj) => ({ ...acc,
        ...obj
      }), {});
      let data = { ...parameters.value,
        ...{
          'world_outlook_id': 2,
          'capabilities': capabilities
        }
      };
      let url = 'role/create_role/';

      if (props.role) {
        url = 'role/rebuild_role/';
        data = { ...data,
          ...{
            'role_id': props.role['id']
          }
        };
      }

      request(url, data, 'POST', {
        'Content-Type': 'application/json'
      }).then(response => {
        // console.log(JSON.stringify(response))
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        if (props.role) {
          store.commit('delete_role_info', {
            role_id: props.role['id'],
            key: null
          });
          message.value = ElMessage.success({
            message: '完成重构',
            duration: 1500
          });
        } else {
          message.value = ElMessage.success({
            message: '完成创建',
            duration: 1500
          });
        }

        emits('completeRole');
      });
    }; // lifecycle


    onMounted(() => {
      if (capabilityTypeOptions.value) {
        capabilityType.value = capabilityTypeOptions.value[0];
      }
    }); // watcher

    watch(() => props.role, newValue => {
      if (newValue) {
        parameters.value.age = newValue['age'];
        parameters.value.avatar = newValue['avatar'];
        parameters.value.nickname = newValue['nickname'];
        parameters.value.work = newValue['work'];
        parameters.value.nationality = newValue['nationality'];
        parameters.value.era = newValue['era'];
        parameters.value.biography = newValue['biography'];
        parameters.value.gender = newValue['gender'];
        parameters.value.race = newValue['race'];

        for (const propertyKey in parameters.value.properties) {
          // console.log(`propertyKey ${propertyKey} = ${JSON.stringify(newValue['properties'][propertyKey])}`)
          parameters.value.properties[propertyKey] = newValue['properties'][propertyKey];
        } // console.log(`assignablePropertyPoint.value = ${assignablePropertyPoint.value} assignedPropertyPoint.value = ${assignedPropertyPoint.value}`)


        if (assignablePropertyPoint.value < assignedPropertyPoint.value) {
          parameters.value.properties = {
            'str': 30,
            'con': 30,
            'siz': 30,
            'dex': 30,
            'app': 30,
            'int': 30,
            'pow': 30,
            'edu': 30
          };
        }

        newValue['capabilities'].forEach(capabilityItem => {
          parameters.value['capabilities'].push({ ...getCapability(capabilityItem['capability_id'], newValue['properties']),
            ...{
              'nature_value': 0
            }
          });
        });
        reorderCapabilities();
      }

      resetConvertedData();
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_slider = _resolveComponent("el-slider");

      const _component_el_divider = _resolveComponent("el-divider");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_unref(ElRow), {
        class: "group-title-row"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          size: 18
        }, {
          default: _withCtx(() => [_createVNode(_unref(UserFilled))]),
          _: 1
        }), _cache[15] || (_cache[15] = _createElementVNode("text", {
          class: "group-title"
        }, "角色基础", -1))]),
        _: 1
      }), _createVNode(AvatarSelectorHorizontal, {
        avatar: parameters.value['avatar'],
        onSelectedAvatar: selectedAvatar,
        ref_key: "avatarSelector",
        ref: avatarSelector
      }, null, 8, ["avatar"]), _createVNode(_unref(ElRow), {
        class: "age-container"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_slider, {
          modelValue: parameters.value['age'],
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => parameters.value['age'] = $event),
          min: 20,
          max: 50
        }, null, 8, ["modelValue"]), _cache[16] || (_cache[16] = _createElementVNode("text", {
          class: "tips emphasize"
        }, "角色一旦在雾海建立投影，年龄值将会固定，绝大多数情况下无法产生变更", -1)), _cache[17] || (_cache[17] = _createElementVNode("text", {
          class: "tips"
        }, " 随着年龄的增加，角色的可用属性点逐渐减少（从490线性降低至475），而能力转化系数逐渐提升（从1.0线性提升至1.9）；部分属性的可用上限也会依据年龄有适当调整 ", -1))]),
        _: 1
      }), _createVNode(_unref(ElRow), {
        class: "single-input-container"
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElCol), {
          span: 6,
          style: {
            "justify-content": "left"
          }
        }, {
          default: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createElementVNode("text", null, "角色名", -1)]))]),
          _: 1
        }), _createVNode(_unref(ElInput), {
          modelValue: parameters.value['nickname'],
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => parameters.value['nickname'] = $event),
          maxlength: "16",
          placeholder: "",
          round: "",
          type: "text",
          clearable: "",
          "show-word-limit": ""
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_unref(ElRow), {
        class: "multiple-select-container"
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElCol), {
          span: 6,
          style: {
            "text-align": "left"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("text", null, "年龄 / " + _toDisplayString(parameters.value['age']), 1)]),
          _: 1
        }), _createVNode(_unref(ElCol), {
          offset: 0,
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElSelect), {
            modelValue: parameters.value['gender'],
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => parameters.value['gender'] = $event),
            placeholder: "选择性别",
            class: _normalizeClass(parameters.value['gender'] ? 'selected-selector' : ''),
            "popper-class": "accountPopper"
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, index => {
              return _createVNode(_unref(ElOption), {
                key: index,
                label: _unref(getGender)(index),
                value: index
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue", "class"])]),
          _: 1
        }), _createVNode(_unref(ElCol), {
          offset: 1,
          span: 9
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElSelect), {
            modelValue: parameters.value['race'],
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => parameters.value['race'] = $event),
            placeholder: "选择种族",
            "popper-class": "accountPopper",
            class: _normalizeClass(parameters.value['race'] ? 'selected-selector' : '')
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, index => {
              return _createVNode(_unref(ElOption), {
                key: index,
                label: _unref(getRace)(index),
                value: _unref(getRace)(index)
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue", "class"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_unref(ElRow), {
        class: "single-input-container"
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElCol), {
          span: 6,
          style: {
            "justify-content": "left"
          }
        }, {
          default: _withCtx(() => [...(_cache[19] || (_cache[19] = [_createElementVNode("text", null, "职业", -1)]))]),
          _: 1
        }), _createVNode(_unref(ElInput), {
          modelValue: parameters.value['work'],
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => parameters.value['work'] = $event),
          maxlength: "16",
          placeholder: "",
          round: "",
          type: "text",
          clearable: "",
          "show-word-limit": ""
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_unref(ElRow), {
        class: "single-input-container"
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElCol), {
          span: 6,
          style: {
            "justify-content": "left"
          }
        }, {
          default: _withCtx(() => [...(_cache[20] || (_cache[20] = [_createElementVNode("text", null, "国籍", -1)]))]),
          _: 1
        }), _createVNode(_unref(ElInput), {
          modelValue: parameters.value['nationality'],
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => parameters.value['nationality'] = $event),
          maxlength: "16",
          placeholder: "",
          round: "",
          type: "text",
          clearable: "",
          "show-word-limit": ""
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_unref(ElRow), {
        class: "single-input-container"
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElCol), {
          span: 6,
          style: {
            "justify-content": "left"
          }
        }, {
          default: _withCtx(() => [...(_cache[21] || (_cache[21] = [_createElementVNode("text", null, "链接天命", -1)]))]),
          _: 1
        }), _createVNode(_unref(ElCol), {
          offset: 0,
          span: 18
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElInput), {
            modelValue: parameters.value['era'],
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => parameters.value['era'] = $event),
            maxlength: "16",
            placeholder: "如：20世纪20年代 或 1920年",
            round: "",
            type: "text",
            clearable: "",
            "show-word-limit": ""
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_unref(ElRow), {
        class: "single-input-container"
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElInput), {
          modelValue: parameters.value['biography'],
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => parameters.value['biography'] = $event),
          rows: 4,
          maxlength: "512",
          "show-word-limit": "",
          clearable: "",
          type: "textarea",
          placeholder: "简要生平"
        }, null, 8, ["modelValue"])]),
        _: 1
      })]), _createElementVNode("div", _hoisted_5, [_createVNode(_unref(ElRow), {
        class: "group-title-row"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          size: 18
        }, {
          default: _withCtx(() => [_createVNode(_unref(Refresh))]),
          _: 1
        }), _createElementVNode("text", _hoisted_6, "能力点数（" + _toDisplayString(convertedPropertyPoint.value) + " / " + _toDisplayString(assignedPropertyPoint.value) + "）", 1)]),
        _: 1
      }), _createVNode(_unref(ElRow), null, {
        default: _withCtx(() => [...(_cache[22] || (_cache[22] = [_createElementVNode("text", {
          class: "tips emphasize"
        }, " 每个属性在不同的能力类别下具备不同相性。如：20岁的角色，其转化系数为1.0，调查技艺中，对敏捷属性的相性为60%，则消耗10点敏捷属性点，最终转化得到调查技艺能力点为6点（10 * 0.6 * 1.0） ", -1)]))]),
        _: 1
      }), _createElementVNode("div", _hoisted_7, [_createVNode(CapabilityRadar, {
        data: convertedData.value,
        capabilities: parameters.value.capabilities,
        "assigned-point-data": assignedCapabilityPoint.value
      }, null, 8, ["data", "capabilities", "assigned-point-data"])]), selectedCapabilityDict.value && convertedData.value ? (_openBlock(), _createElementBlock("div", _hoisted_8, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(propertyKeys, (key, index) => {
        return _createVNode(_unref(ElRow), {
          key: index,
          class: "convert-property-item"
        }, {
          default: _withCtx(() => [_createElementVNode("text", {
            class: "desc",
            style: _normalizeStyle(compatibilityTextStyle(getPropertyCompatibility(key)))
          }, _toDisplayString(_unref(getProperty)(key)) + "相性  " + _toDisplayString(getPropertyCompatibility(key)) + "%  /   " + _toDisplayString(convertedData.value[capabilityType.value]['converted_point'][key]), 5), _cache[23] || (_cache[23] = _createElementVNode("text", {
            class: "min-value"
          }, "0", -1)), _createVNode(_unref(ElCol), {
            style: {
              "flex": "1"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_slider, {
              modelValue: convertedData.value[capabilityType.value]['converted_point'][key],
              "onUpdate:modelValue": $event => convertedData.value[capabilityType.value]['converted_point'][key] = $event,
              disabled: getConvertMaxValue(key) === 0,
              min: 0,
              max: getConvertMaxValue(key)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "max"])]),
            _: 2
          }, 1024), _createElementVNode("text", _hoisted_9, _toDisplayString(getConvertMaxValue(key)), 1)]),
          _: 2
        }, 1024);
      }), 64))])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_unref(ElRow), {
        class: "group-title-row"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          size: 18
        }, {
          default: _withCtx(() => [_createVNode(_unref(Postcard))]),
          _: 1
        }), _createElementVNode("text", _hoisted_12, "属性点数（" + _toDisplayString(assignedPropertyPoint.value) + " / " + _toDisplayString(assignablePropertyPoint.value) + "）", 1)]),
        _: 1
      }), _createVNode(_unref(ElRow), null, {
        default: _withCtx(() => [__props.role ? (_openBlock(), _createElementBlock("text", _hoisted_13, " 重构建模式下，并不会加载演出中因为各种遭遇产生的属性调整，但调整仍然存在于角色，在构建完成之后重新被加载 ")) : _createCommentVNode("", true)]),
        _: 1
      }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parameters.value['properties'], (value, key, index) => {
        return _openBlock(), _createBlock(_unref(ElRow), {
          class: "role-property-item",
          key: index
        }, {
          default: _withCtx(() => [adjustPropertyPoint.value[key][0] + adjustPropertyPoint.value[key][1] !== 0 ? (_openBlock(), _createBlock(_unref(ElPopover), {
            key: 0,
            placement: "left",
            width: "6rem",
            trigger: "click",
            title: "年龄影响",
            content: getPopoverContent(key),
            "popper-class": "transaction-prop"
          }, {
            reference: _withCtx(() => [_createElementVNode("text", _hoisted_14, _toDisplayString(_unref(getProperty)(key)) + " / " + _toDisplayString(value), 1)]),
            _: 2
          }, 1032, ["content"])) : (_openBlock(), _createElementBlock("text", _hoisted_15, [_createElementVNode("text", _hoisted_16, _toDisplayString(_unref(getProperty)(key)) + " / " + _toDisplayString(value), 1)])), _createElementVNode("text", _hoisted_17, _toDisplayString(getPropertyMinValue(key)), 1), _createVNode(_unref(ElCol), {
            style: {
              "flex": "1"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_slider, {
              modelValue: parameters.value['properties'][key],
              "onUpdate:modelValue": $event => parameters.value['properties'][key] = $event,
              disabled: getPropertyMinValue(key) === getPropertyMaxValue(key),
              min: getPropertyMinValue(key),
              max: getPropertyMaxValue(key),
              onInput: $event => propertyChanged(key)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "min", "max", "onInput"])]),
            _: 2
          }, 1024), _createElementVNode("text", _hoisted_18, _toDisplayString(getPropertyMaxValue(key)), 1)]),
          _: 2
        }, 1024);
      }), 128)), _createVNode(_component_el_divider), _createVNode(_unref(ElRow), {
        style: {
          "margin-top": "16px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElCol), {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElRow), null, {
            default: _withCtx(() => [_cache[24] || (_cache[24] = _createElementVNode("text", {
              class: "generated-item-title"
            }, "生命值", -1)), _createVNode(_unref(ElProgress), {
              percentage: 100,
              "text-inside": true,
              "stroke-width": 16,
              class: "attribute-item-progress hp_progress"
            }, {
              default: _withCtx(() => [_createElementVNode("text", _hoisted_19, _toDisplayString(_unref(getHealthPoint)(parameters.value)), 1)]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_unref(ElCol), {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElRow), null, {
            default: _withCtx(() => [_cache[25] || (_cache[25] = _createElementVNode("text", {
              class: "generated-item-title"
            }, "法力值", -1)), _createVNode(_unref(ElProgress), {
              percentage: 100,
              "text-inside": true,
              "stroke-width": 16,
              class: "attribute-item-progress mp_progress"
            }, {
              default: _withCtx(() => [_createElementVNode("text", _hoisted_20, _toDisplayString(_unref(getMagicPoint)(parameters.value)), 1)]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_unref(ElCol), {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElRow), null, {
            default: _withCtx(() => [_cache[26] || (_cache[26] = _createElementVNode("text", {
              class: "generated-item-title"
            }, "理智值", -1)), _createVNode(_unref(ElProgress), {
              percentage: 100,
              "text-inside": true,
              "stroke-width": 16,
              class: "attribute-item-progress san_progress"
            }, {
              default: _withCtx(() => [_createElementVNode("text", _hoisted_21, _toDisplayString(parameters.value.properties.pow), 1)]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_unref(ElRow), {
        style: {
          "margin-top": "16px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElCol), {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElRow), {
            class: "generated-item-row"
          }, {
            default: _withCtx(() => [_cache[27] || (_cache[27] = _createElementVNode("text", {
              class: "generated-item-title"
            }, "物理强度", -1)), _createElementVNode("text", _hoisted_22, _toDisplayString(`${_unref(getDamageAndBuild)(parameters.value)[1]}（${_unref(getDamageAndBuild)(parameters.value)[0]}）`), 1)]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_unref(ElCol), {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElRow), {
            class: "generated-item-row"
          }, {
            default: _withCtx(() => [_cache[28] || (_cache[28] = _createElementVNode("text", {
              class: "generated-item-title"
            }, "灵体强度", -1)), _createElementVNode("text", _hoisted_23, _toDisplayString(`${_unref(getDamageAndBuild)(parameters.value, true)[1]}（${_unref(getDamageAndBuild)(parameters.value, true)[0]}）`), 1)]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_unref(ElCol), {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElRow), {
            class: "generated-item-row"
          }, {
            default: _withCtx(() => [_cache[29] || (_cache[29] = _createElementVNode("text", {
              class: "generated-item-title"
            }, "移动力", -1)), _createElementVNode("text", _hoisted_24, _toDisplayString(_unref(getMovement)(parameters.value)), 1)]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]), _createElementVNode("div", _hoisted_25, [_createVNode(_unref(ElRow), {
        class: "group-title-row"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          size: 18
        }, {
          default: _withCtx(() => [_createVNode(_unref(List))]),
          _: 1
        }), _cache[30] || (_cache[30] = _createElementVNode("text", {
          class: "group-title"
        }, "能力列表", -1))]),
        _: 1
      }), _createVNode(_unref(ElRow), null, {
        default: _withCtx(() => [_createElementVNode("text", _hoisted_26, [_cache[33] || (_cache[33] = _createTextVNode(" 角色年龄为 ", -1)), _createElementVNode("b", null, _toDisplayString(parameters.value['age']), 1), _cache[34] || (_cache[34] = _createTextVNode("     转化系数为 ", -1)), _createElementVNode("b", null, _toDisplayString(conversionCoefficient.value.toFixed(1)), 1), _cache[35] || (_cache[35] = _createTextVNode("     ", -1)), selectedCapabilityDict.value ? (_openBlock(), _createElementBlock("span", _hoisted_27, [_cache[31] || (_cache[31] = _createTextVNode(" 能力点分配 ", -1)), _createElementVNode("b", null, "（" + _toDisplayString(assignedCapabilityPoint.value[capabilityType.value]) + " / " + _toDisplayString(assignableCapabilityPoint.value[capabilityType.value]) + "）", 1), _cache[32] || (_cache[32] = _createTextVNode("  ", -1))])) : _createCommentVNode("", true)])]),
        _: 1
      }), _createVNode(_unref(ElRow), null, {
        default: _withCtx(() => [...(_cache[36] || (_cache[36] = [_createElementVNode("text", {
          class: "tips emphasize"
        }, " 重构建模式下，并不会加载演出中因为各种遭遇产生的能力调整。在重构建之后，成长数值部分完全保留（超出上限部分存在但无效），分配数值部分全部返还 ", -1), _createElementVNode("text", {
          class: "tips"
        }, " 必须通过角色属性转化出对应能力类别的天性能力点，方可进行数值分配 ", -1)]))]),
        _: 1
      }), _createVNode(_unref(ElRow), {
        class: "multiple-select-container"
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElSegmented), {
          modelValue: capabilityType.value,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => capabilityType.value = $event),
          options: capabilityTypeOptions.value
        }, {
          default: _withCtx(({
            item
          }) => [_createElementVNode("text", null, _toDisplayString(capabilityConfigure.value[item]?.desc) + "(" + _toDisplayString(assignableCapabilityPoint.value[item]) + ")", 1)]),
          _: 1
        }, 8, ["modelValue", "options"])]),
        _: 1
      }), _createElementVNode("div", _hoisted_28, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(capabilities.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["capability-card", capabilitiesIds.value.includes(item.capability_id.toString()) ? 'selected' : '']),
          onClick: $event => addCapability(item)
        }, [_createElementVNode("text", null, _toDisplayString(item['desc']), 1)], 10, _hoisted_29);
      }), 128))]), _createElementVNode("div", _hoisted_30, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parameters.value['capabilities'], (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["role-capability-item", selectedCapabilityItem.value && item['capability_id'] === selectedCapabilityItem.value['capability_id'] ? 'selected-role-capability-item' : '']),
          key: index,
          onClick: $event => clickCapabilityItem(item)
        }, [_createElementVNode("div", _hoisted_32, [_createElementVNode("text", _hoisted_33, _toDisplayString(item['type']['desc']) + " / " + _toDisplayString(item['desc']) + " /  " + _toDisplayString(getCapabilityMinValue(item) + item['nature_value']), 1), _createVNode(_component_el_icon, {
          onClick: $event => removeCapability($event, item)
        }, {
          default: _withCtx(() => [_createVNode(_unref(CloseBold))]),
          _: 1
        }, 8, ["onClick"])]), _createElementVNode("div", _hoisted_34, [_createElementVNode("text", _hoisted_35, "    " + _toDisplayString(item['explain']), 1)]), _createElementVNode("div", _hoisted_36, [_createElementVNode("text", _hoisted_37, _toDisplayString(getCapabilityMinValue(item)), 1), _createVNode(_component_el_slider, {
          modelValue: parameters.value['capabilities'][index]['nature_value'],
          "onUpdate:modelValue": $event => parameters.value['capabilities'][index]['nature_value'] = $event,
          min: 0,
          max: getCapabilityMaxValue(item) - getCapabilityMinValue(item),
          disabled: getCapabilityMinValue(item) >= getCapabilityMaxValue(item)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "max", "disabled"]), _createElementVNode("text", _hoisted_38, _toDisplayString(getCapabilityMaxValue(item)), 1)])], 10, _hoisted_31);
      }), 128))])])])]), _createVNode(_unref(ElRow), {
        style: {
          "margin-top": "36px",
          "justify-content": "flex-end",
          "width": "100%"
        }
      }, {
        default: _withCtx(() => [...(_cache[37] || (_cache[37] = [_createElementVNode("text", {
          class: "tips"
        }, " 每位选中者可创建三张角色卡用于链接演出，每张角色卡在创建之后仍有一次重新构建的机会 ", -1)]))]),
        _: 1
      }), _createVNode(_unref(ElRow), {
        style: {
          "justify-content": "flex-end",
          "margin-top": "0.5rem"
        }
      }, {
        default: _withCtx(() => [acquiredCapabilityTypes.value.length > 1 ? (_openBlock(), _createBlock(_unref(ElButton), {
          key: 0,
          class: "reorder",
          onClick: reorderCapabilities
        }, {
          default: _withCtx(() => [...(_cache[38] || (_cache[38] = [_createTextVNode(" 能力项排序 ", -1)]))]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_unref(ElButton), {
          class: "submit",
          onClick: submitRole
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.role ? `完成重构(${__props.role['reborn']})` : '创建角色'), 1)]),
          _: 1
        })]),
        _: 1
      })]), _createVNode(_component_el_dialog, {
        modelValue: confirmationDialog.value,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => confirmationDialog.value = $event),
        title: confirmationTitle.value,
        width: "800"
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_39, [_createVNode(_unref(ElButton), {
          onClick: _cache[9] || (_cache[9] = $event => {
            confirmationDialog.value = false;
            submitRole($event, true);
          })
        }, {
          default: _withCtx(() => [...(_cache[39] || (_cache[39] = [_createTextVNode(" 确认 ", -1)]))]),
          _: 1
        }), _createVNode(_unref(ElButton), {
          class: "cancel",
          onClick: _cache[10] || (_cache[10] = $event => confirmationDialog.value = false)
        }, {
          default: _withCtx(() => [...(_cache[40] || (_cache[40] = [_createTextVNode("取消", -1)]))]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("text", null, _toDisplayString(confirmationTips.value), 1)]),
        _: 1
      }, 8, ["modelValue", "title"]), _createVNode(_component_el_dialog, {
        modelValue: secondaryConfirmationDialog.value,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => secondaryConfirmationDialog.value = $event),
        title: confirmationTitle.value,
        width: "800"
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_40, [_createVNode(_unref(ElButton), {
          onClick: _cache[12] || (_cache[12] = $event => {
            secondaryConfirmationDialog.value = false;
            secondaryConfirmation.value = true;
            submitRole($event, true);
          })
        }, {
          default: _withCtx(() => [...(_cache[41] || (_cache[41] = [_createTextVNode(" 确认 ", -1)]))]),
          _: 1
        }), _createVNode(_unref(ElButton), {
          class: "cancel",
          onClick: _cache[13] || (_cache[13] = $event => secondaryConfirmationDialog.value = false)
        }, {
          default: _withCtx(() => [...(_cache[42] || (_cache[42] = [_createTextVNode("取消", -1)]))]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("text", null, _toDisplayString(confirmationTips.value), 1)]),
        _: 1
      }, 8, ["modelValue", "title"])], 64);
    };
  }

};